export const environment = {
  /** Shown as a banner so nobody mistakes stage for prod; null hides it. */
  envLabel: 'stage' as string | null,
  production: true,
  apiUrl: 'https://api.stage.muufree.com/api/v2'
};
